import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'

export const payouts = createQueryKeys('payouts', {
  all: null,
  allPaginated: (query?: any) => [query],
})

export type PayoutsKeys = inferQueryKeys<typeof payouts>
